import { Component } from '@angular/core';
import { MechanicsService } from '../_services/mechanics.service';
import { MainService } from '../_services/main.service';

@Component({
	selector: 'version-selector',
	templateUrl: './version-selector.component.html',
	styleUrl: './version-selector.component.css'
})
export class VersionSelectorComponent {

	constructor(public ms:MechanicsService,
				public mas : MainService){


	}

	async changeViennaVersion() {
		// Need to reload all Categories, Devisions and Sections in Vienna 9, rehydrate objects, rebuild tooltips, etc.
		await this.ms.buildStuff();
		this.mas.sendImageData(); // Resending the same image to the backend, specifying viennaVersion
		this.ms.savePreferences();
	}


}
